import {
  Film, Heart, Sparkles, MapPin, Scissors, Phone, Sun
} from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const VIDEO_LIBRARY = [
  {
    id: 'keep-your-promises',
    title: 'Keep Your Promises',
    description: 'Three professionals. Three countries. Three promises to the people they love. One shared struggle — and one moment that sets them all free. Our brand anthem.',
    tagline: 'Keep your promises.',
    duration: '1:20',
    category: 'Brand',
    icon: Film,
    color: '#dc2626',
    src: `${API}/api/media/videos/video-promises-90s.mp4`,
    featured: true,
  },
  {
    id: 'sunday',
    title: 'Sunday',
    description: 'What if compliance didn\'t steal your weekends? A story about getting your Sundays back — because the best technology is the kind you never have to think about.',
    tagline: 'Get your Sundays back.',
    duration: '0:32',
    category: 'Brand',
    icon: Heart,
    color: '#e85d75',
    src: `${API}/api/media/videos/video-sunday-30s.mp4`,
  },
  {
    id: 'how-it-works',
    title: 'How It Works',
    description: 'From raw data to complete compliance — see how intelligent automation transforms the way tax teams work. No UI, no jargon. Just the feeling of things working the way they should.',
    tagline: 'This is how tax compliance should feel.',
    duration: '0:32',
    category: 'Brand',
    icon: Sparkles,
    color: '#6366f1',
    src: `${API}/api/media/videos/video-howitworks-30s.mp4`,
  },
  {
    id: 'the-pickup',
    title: 'The Pickup',
    description: 'A working parent races against the clock to make it to the school gate on time. Because when compliance is handled, you can be there for the moments that matter.',
    tagline: 'Be there for the moments that matter.',
    duration: '0:32',
    category: 'Brand',
    icon: MapPin,
    color: '#f97316',
    src: `${API}/api/media/videos/video-pickup-30s.mp4`,
  },
  {
    id: 'the-haircut',
    title: 'The Haircut',
    description: 'He keeps cancelling the same appointment. Three times the notification gets swiped away. Then one day, everything is green. He finally makes it to the barber chair.',
    tagline: 'Finally, time for yourself.',
    duration: '0:32',
    category: 'Brand',
    icon: Scissors,
    color: '#10b981',
    src: `${API}/api/media/videos/video-haircut-30s.mp4`,
  },
  {
    id: 'the-sunday-call',
    title: 'The Sunday Call',
    description: 'The phone rings on a Sunday morning. It\'s the boss. But instead of panic, he answers with calm confidence: it\'s already done. He hangs up and goes back to making pancakes.',
    tagline: 'Already done.',
    duration: '0:32',
    category: 'Brand',
    icon: Phone,
    color: '#3b82f6',
    src: `${API}/api/media/videos/video-sundaycall-30s.mp4`,
  },
  {
    id: 'the-rooftop-lunch',
    title: 'The Rooftop Lunch',
    description: 'A Mediterranean rooftop. Friends, food, golden light. No one is checking anything. No one is anywhere else. Just a long lunch that nobody wants to end.',
    tagline: 'Summer just feels better.',
    duration: '0:35',
    category: 'Summer \'26',
    icon: Sun,
    color: '#f59e0b',
    src: `${API}/api/media/videos/video-rooftoplunch-35s.mp4`,
  },
  {
    id: 'the-gelato-queue',
    title: 'The Gelato Queue',
    description: 'A city in motion. Then a corner turned, and everything slows. An Italian piazza, a queue that nobody minds, and a scoop of pistachio that tastes like freedom.',
    tagline: 'Summer just feels better.',
    duration: '0:31',
    category: 'Summer \'26',
    icon: Sun,
    color: '#f59e0b',
    src: `${API}/api/media/videos/video-gelatoqueue-31s.mp4`,
  },
];
